import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import './Cadastro.css';

/**
 * Página para finalizar cadastro com token
 * Conforme doc 04-fluxo-de-autenticacao.md
 */

const FinalizarCadastro = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!senha) {
      setError('Senha é obrigatória');
      return;
    }

    if (senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    if (senha !== confirmarSenha) {
      setError('As senhas não coincidem');
      return;
    }

    setLoading(true);

    try {
      await apiClient.post('/cadastro/finalizar', {
        token_cadastro: token,
        senha: senha,
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      console.error('Erro ao finalizar cadastro:', err);
      setError(err.response?.data?.error || 'Erro ao finalizar cadastro. Token inválido ou expirado?');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="cadastro-container">
        <div className="cadastro-box">
          <h1>✅ Cadastro Finalizado!</h1>
          <p>Seu cadastro foi concluído com sucesso!</p>
          <p>Redirecionando para login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cadastro-container">
      <div className="cadastro-box">
        <h1>🃏 NerdzPoker</h1>
        <h2>Finalizar Cadastro</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nova Senha</label>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              disabled={loading}
              placeholder="Mínimo 6 caracteres"
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label>Confirmar Senha</label>
            <input
              type="password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              required
              disabled={loading}
              placeholder="Digite a senha novamente"
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Finalizando...' : 'Finalizar Cadastro'}
          </button>

          <div className="cadastro-footer">
            <p className="footer-signature">Produzido by <strong>Chicão</strong></p>
            <p>Já tem uma conta? <a href="/login">Faça login aqui</a></p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FinalizarCadastro;
